<div class="app flex-row align-items-center bg-login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <h1 class="font-weight-bold text-muted">ログイン</h1>
              <div style="height: 1px"></div>
              <p class="text-muted mb-4">ログインIDとパスワードを入力してください</p>
              @if (loginError) {
                <p class="mb-4 text-danger">{{ errorMessage || 'ログインに失敗しました' }}</p>
              }
              <form novalidate #myLogin="ngForm" (ngSubmit)="login()">
                <div class="input-group mb-3">
                  <div class="input-group-prepend d-none d-sm-flex">
                    <span class="input-group-text bg-login-input"><i class="fa s-icon-member text-white"></i></span>
                  </div>
                  <input type="text" class="form-control" placeholder="ログインID" [(ngModel)]="member.loginId" name="loginId" required>
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend d-none d-sm-flex">
                    <span class="input-group-text bg-login-input"><i class="fa s-icon-passward text-white"></i></span>
                  </div>
                  <input type="password" class="form-control" placeholder="パスワード" autocomplete="off" [(ngModel)]="member.password" name="password" required>
                </div>
                <div class="row">
                  <div class="col-sm-8 mb-2">
                    <a routerLink="/reset-password" class="btn btn-link px-0"><i class="fa fa-question"></i> パスワードを忘れた方はこちら</a>
                  </div>
                  <div class="col-sm-4 text-right">
                    <button type="submit" class="btn btn-primary px-4 text-white" [disabled]="myLogin.invalid">ログイン</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
